export const apiRoutes = {
    LOGIN: 'auth/login',
    REGISTER: 'auth/register',
    DASHBOARD: '/dashboard',    
    LIST_ALL_USERS: '/list-all-users',
    ADD_USER: '/add-user',
    MODIFY_USER: '/modify-user/:id',
    CHANGE_PASSWORD: '/change-password',
    NOT_FOUND: '*',
    BILLING: 'billing',
    BILLINGBYID: 'getById',
    BILLING_BY_USER: 'billing/user',
    BILLING_DATE_RANGE: 'billing/date-range',
    BILLING_ITEM: 'billingItems',
    UPDATEBILLING: 'billing/updateBilling',
    FINANCIAL_YEAR: 'financialYear',
    BILLING_CATEGORY_UPDATE: 'billingCategory/categories',
    BILLING_CATEGORY_DELETE: 'billingCategory/categories',
    DASHBOARD_DATA: 'dashboard/summary',
    CUSTOMER_DETAILS: 'billing/customer',
    // CREATE_FINANCIAL_YEAR: '/create-financial-year',
    // UPDATE_FINANCIAL_YEAR: '/update-financial-year/:id',
    // DELETE_FINANCIAL_YEAR: '/delete-financial-year/:id',
    // GET_FINANCIAL_YEAR: '/get-financial-year/:id',
    // GET_ALL_FINANCIAL_YEARS: '/get-all-financial-years',
    PAYMENT_TYPE: 'paymentType',
    BILLING_CATEGORY: 'billingCategory',
    // GET_BILLING_CATEGORIES: '/get-billing-categories',
    // CREATE_BILLING_CATEGORY: '/create-billing-category',
    // UPDATE_BILLING_CATEGORY: '/update-billing-category/:id',
    // DELETE_BILLING_CATEGORY: '/delete-billing-category/:id',
    // GET_BILLING_CATEGORY: '/get-billing-category/:id',
    // GET_ALL_BILLING_CATEGORIES: '/get-all-billing-categories',
    // CREATE_BILLING: '/create-billing',
    // UPDATE_BILLING: '/update-billing/:id',
    // DELETE_BILLING: '/delete-billing/:id',
    // GET_BILLING: '/get-billing/:id',
    // GET_ALL_BILLINGS: '/get-all-billings',
    // CREATE_USER: '/create-user',
    // UPDATE_USER: '/update-user/:id',
    // DELETE_USER: '/delete-user/:id',
    // GET_USER: '/get-user/:id',
    // GET_ALL_USERS: '/get-all-users',
    // CREATE_ROLE: '/create-role',
    // UPDATE_ROLE: '/update-role/:id',
    // DELETE_ROLE: '/delete-role/:id',
    // GET_ROLE: '/get-role/:id',
    // GET_ALL_ROLES: '/get-all-roles',    
    // CREATE_PERMISSION: '/create-permission',
    // UPDATE_PERMISSION: '/update-permission/:id',
    // DELETE_PERMISSION: '/delete-permission/:id',
    // GET_PERMISSION: '/get-permission/:id',
    // GET_ALL_PERMISSIONS: '/get-all-permissions',
    // ASSIGN_ROLE_TO_USER: '/assign-role-to-user/:userId/:roleId',
    // GET_USER_ROLES: '/get-user-roles/:userId',      
    // ASSIGN_PERMISSION_TO_ROLE: '/assign-permission-to-role/:roleId/:permissionId',
    // GET_ROLE_PERMISSIONS: '/get-role-permissions/:roleId',
    // GET_USER_PERMISSIONS: '/get-user-permissions/:userId',
    // GET_USER_BY_EMAIL: '/get-user-by-email/:email',
    // GET_USER_BY_USERNAME: '/get-user-by-username/:username',
    // GET_USER_BY_PHONE: '/get-user-by-phone/:phone',
    // GET_USER_BY_ID: '/get-user-by-id/:id',
    // GET_USER_BY_NAME: '/get-user-by-name/:name',
    // GET_USER_BY_ROLE: '/get-user-by-role/:roleId',
    // GET_USER_BY_STATUS: '/get-user-by-status/:status',
    // GET_USER_BY_CREATED_AT: '/get-user-by-created-at/:createdAt',
    // GET_USER_BY_UPDATED_AT: '/get-user-by-updated-at/:updatedAt',
    // GET_USER_BY_DELETED_AT: '/get-user-by-deleted-at/:deletedAt',
    // GET_USER_BY_LAST_LOGIN: '/get-user-by-last-login/:lastLogin',
    // GET_USER_BY_LOGIN_COUNT: '/get-user-by-login-count/:loginCount',
}